<nav
    class="flex flex-col h-full gap-y-10 py-10 whitespace-nowrap px-[18px]"
    [ngClass]="{'min-w-[240px]': !isSideBarCollapsedNow,'collapsed':isSideBarCollapsedNow}"
>
    <div [ngClass]="{'flex-between-center': !isSideBarCollapsedNow, 'flex-center-center': isSideBarCollapsedNow}">
        <img *ngIf="isSideBarCollapsedNow" src="/assets/imgs/logo/v2-socialscan-dark.png" alt="logo" class="w-auto h-[37px]" />
        <img *ngIf="!isSideBarCollapsedNow" src="/assets/imgs/logo/v2-socialscan.png" alt="logo" class="w-auto h-[37px]" />

        <img
            *ngIf="!isSideBarCollapsedNow"
            src="/assets/imgs/v2-collapse.png"
            alt=""
            [nz-tooltip]="sideBarCollapsed ? 'Expand Menu' : 'Collapse Menu'"
            class="w-auto h-5 cursor-pointer opacity-30 hover:opacity-100 max-md:hidden"
            [ngClass]="{'rotate-180':sideBarCollapsed}"
            [nzTooltipPlacement]="'bottom'"
            (click)="handleToggleSideBar()"
        />
    </div>
    <div class="flex-1 min-h-0 flex flex-col gap-y-4">
        <app-meme-search></app-meme-search>

        <div class="overflow-y-auto flex-1 small-scrollbar space-y-1 overflow-x-hidden w-[calc(100%+10px)] pr-2.5">
            <div *ngIf="!isSideBarCollapsedNow" [ngClass]="['nav-item','has-link']" [routerLink]="['/','meme-dashboard']" [routerLinkActive]="'active'">
                <span nz-icon nzType="antd:trending" class="text-xl" nzTheme="outline"></span>
                <div class="flex-start-center gap-x-1.5">
                    <span>MEME Smart Buy</span>
                </div>
            </div>

            <div
                [ngClass]="['nav-item','has-link']"
                [routerLink]="['/','hemera','agent','mining-days']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
            >
                <span nz-icon nzType="antd:v2-game" class="text-xl" nzTheme="outline"></span>
                <span>UDF Mining Game</span>
            </div>

            <div [ngClass]="['nav-item','!cursor-default']">
                <span nz-icon nzType="antd:v2-robot" class="text-xl" nzTheme="outline"></span>
                <div class="flex-start-center gap-x-1.5 nav-text">
                    <span>AI Agent</span>
                </div>
            </div>

            <div
                *ngIf="!isSideBarCollapsedNow"
                [ngClass]="['nav-sub-item']"
                (click)="goToHunterAgent()"
                nz-popover
                [nzPopoverTitle]="null"
                nzPopoverPlacement="right"
                [nzPopoverContent]="hunterAgentPopTpl"
                [nzPopoverOverlayClassName]="'no-bg no-padding no-arrow-modal'"
            >
                <div class="w-5"></div>
                <div class="flex-start-center gap-x-1.5 nav-text">
                    <span>Hunter Agent</span>
                </div>
            </div>

            <div
                *ngIf="!isSideBarCollapsedNow"
                [ngClass]="['nav-sub-item']"
                (click)="goToNyXAgent()"
                nz-popover
                [nzPopoverTitle]="null"
                nzPopoverPlacement="right"
                [nzPopoverContent]="nyxAgentPopTpl"
                [nzPopoverOverlayClassName]="'no-bg no-padding no-arrow-modal'"
            >
                <div class="w-5"></div>
                <div class="flex-start-center gap-x-1.5 nav-text">
                    <span>NyX Agent</span>
                </div>
            </div>

            <div class="divider !my-4"></div>

            <div [ngClass]="['nav-item','has-link']" [routerLink]="['/my-profile']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
                <span nz-icon nzType="antd:v2-user" class="text-xl" nzTheme="outline"></span>
                <span>Profile</span>
            </div>

            <div [ngClass]="['nav-item','has-link']" [routerLink]="['/referral']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
                <span nz-icon nzType="antd:v2-share" class="text-xl" nzTheme="outline"></span>
                <span>Referral</span>
            </div>

            <div *ngIf="userService.isAuthenticated  && !isSideBarCollapsedNow" class="pt-2 pl-0.5">
                <button nz-button class="!bg-[#F7F7F780] !border-black !border-opacity-10 w-full !pl-2" (click)="openCheckInModal()">
                    <div class="flex-between-center w-full">
                        <div class="flex-start-center gap-x-2">
                            <span nz-icon nzType="antd:v2-calendar" class="text-xl" nzTheme="outline"></span>

                            <div class="text-sm font-semibold">Daily Check In</div>

                            <div class="w-[22px] h-[22px] rounded-full bg-gradient-to-r from-[#c9fffc] to-[#ffeba3] flex-center-center">
                                <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div class="space-y-8">
        <div>
            <!-- Get Started -->
            <ng-container *ngIf="!commonService.isMobile">
                <button
                    *ngIf="userService.isAuthenticated && percentage !== 100 && !isSideBarCollapsedNow"
                    nz-button
                    class="get-started-btn !bg-[#FFF9E5]"
                    nz-popover
                    [(nzPopoverVisible)]="getStartedVisible"
                    [nzPopoverTitle]="stepTitleTemplate"
                    [nzPopoverContent]="stepTemplate"
                >
                    <div class="flex-between-center w-full">
                        <div class="flex-start-center gap-x-2">
                            <app-progress-circle [percentage]="percentage" class="w-[24px] h-[24px]"></app-progress-circle>
                            <div>Get Started</div>

                            <div class="w-[22px] h-[22px] rounded-full bg-gradient-to-r from-[#c9fffc] to-[#ffeba3] flex-center-center">
                                <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                            </div>
                        </div>

                        <span nz-icon nzType="caret-right" class="text-sm" nzTheme="outline"></span>
                    </div>
                </button>
            </ng-container>

            <ng-container *ngIf="commonService.isMobile">
                <button
                    *ngIf="userService.isAuthenticated && percentage !== 100 && !isSideBarCollapsedNow"
                    nz-button
                    class="get-started-btn md:hidden !bg-[#FFF9E5]"
                    (click)="getStartedVisible = true"
                >
                    <div class="w-full flex-between-center">
                        <div class="flex-start-center gap-x-2">
                            <app-progress-circle [percentage]="percentage" class="w-[24px] h-[24px]"></app-progress-circle>
                            <div>Get Started</div>

                            <div class="w-[22px] h-[22px] rounded-full bg-gradient-to-r from-[#c9fffc] to-[#ffeba3] flex-center-center">
                                <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                            </div>
                        </div>

                        <span nz-icon nzType="caret-right" class="text-sm" nzTheme="outline"></span>
                    </div>
                </button>
            </ng-container>

            <div class="h-4"></div>

            <button
                *ngIf="!walletStatusService.isWalletConnected && !tgService.isTGLogin"
                nz-button
                nzType="primary"
                class="connect-wallet-btn"
                [ngClass]="{'!h-10': isSideBarCollapsedNow}"
                nzSize="large"
                (click)="toggleWalletConnection()"
            >
                <ng-container *ngIf="!isSideBarCollapsedNow">
                    <div class="w-fit colorful-text">Connect Wallet</div>
                    <img src="/assets/imgs/v2-long-right-arrow-colorful.png" alt="go" class="w-6 h-6" />
                </ng-container>
                <ng-container *ngIf="isSideBarCollapsedNow">
                    <img src="/assets/imgs/icon/wallet-v2.png" class="h-auto w-5" alt="" />
                </ng-container>
            </button>

            <ng-container *ngIf="walletStatusService.isWalletConnected || tgService.isTGLogin">
                <button
                    *ngIf="!isSideBarCollapsedNow"
                    nzGhost
                    nz-button
                    class="connect-wallet-btn !border-none !shadow-none !p-0 has-link"
                    nzSize="large"
                    [routerLink]="['/my-profile']"
                >
                    <app-hexagon-img class="w-11" [imgUrl]="userService.userAvatar"></app-hexagon-img>
                    <div class="flex-1 text-left">{{ userService.userName | address}}</div>
                    <div
                        #moreDropdown
                        class="w-10 h-10 rounded-lg hover:bg-black hover:bg-opacity-6 flex-center-center"
                        nz-dropdown
                        nzTrigger="click"
                        [nzDropdownMenu]="menu"
                        nzPlacement="topRight"
                        [(nzVisible)]="dropdownVisible"
                        (nzVisibleChange)="onDropdownVisibleChange($event)"
                        (click)="$event.stopPropagation();$event.preventDefault()"
                    >
                        <span *ngIf="!walletStatusService.disconnecting" nz-icon nzType="antd:v2-more" class="text-2xl text-black" nzTheme="outline"></span>
                    </div>

                    <span *ngIf="walletStatusService.disconnecting" class="text-white text-2xl" nz-icon nzType="loading" nzTheme="outline"></span>
                </button>

                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <app-profile-settings-dropdown></app-profile-settings-dropdown>
                </nz-dropdown-menu>

                <app-hexagon-img *ngIf="isSideBarCollapsedNow" class="w-12 -ml-1" [imgUrl]="userService.userAvatar"></app-hexagon-img>
            </ng-container>
        </div>

        <div class="space-y-4">
            <div class="flex-between-center gap-5" [ngClass]="{'flex-col': isSideBarCollapsedNow}">
                <div class="flex-start-center gap-5" [ngClass]="{'flex-col': isSideBarCollapsedNow}">
                    <a href="https://discord.gg/ZqYx5dXsAh" target="_blank" class="social-icon">
                        <span nz-icon nzType="antd:discord" nzTheme="fill" class="text-lg"></span>
                    </a>

                    <a href="https://twitter.com/socialscan_io" target="_blank" class="social-icon">
                        <span nz-icon nzType="antd:x" nzTheme="fill" class="text-base"></span>
                    </a>

                    <a href="https://t.me/SocialScanAnn" target="_blank" class="social-icon">
                        <span nz-icon nzType="antd:telegram" nzTheme="fill" class="text-base"></span>
                    </a>
                </div>

                <button
                    *ngIf="walletStatusService.isWalletConnected"
                    nz-button
                    nzShape="round"
                    nzSize="small"
                    nz-popover
                    class="!w-8 !h-8 !border-none max-md:hidden relatiiive"
                    [nzPopoverTitle]="notifiTitleTemplate"
                    [nzPopoverContent]="notifTemplate"
                    nzPopoverPlacement="right"
                    nzPopoverTrigger="click"
                    [nzPopoverOverlayStyle]="{ maxWidth: '460px' }"
                    [nzPopoverArrowPointAtCenter]="false"
                    [(nzPopoverVisible)]="notfiVisible"
                >
                    <span nz-icon nzType="antd:v2-notif" class="text-lg"></span>
                    <div *ngIf="hasUnreadNotifications " class="absolute w-2 h-2 rounded-full bg-[#FF462A] right-0 top-0"></div>
                </button>
            </div>

            <div *ngIf="!isSideBarCollapsedNow" class="w-full flex-between-center text-xs">
                <a
                    href="https://drive.google.com/drive/folders/11wmioe_npIbiMoCzIgGCvHhuGfYRoq5y?usp=sharing"
                    class="text-black text-opacity-30"
                    target="_blank"
                >
                    Brand Kit
                </a>
                <div class="h-4 w-[1px] bg-line"></div>
                <a href="https://www.thehemera.com/blogs" class="text-black text-opacity-30" target="_blank">Blog</a>
                <div class="h-4 w-[1px] bg-line"></div>
                <a href="https://www.thehemera.com/about-us" class="text-black text-opacity-30" target="_blank">About Us</a>
            </div>
        </div>
    </div>
</nav>

<!-- Templates -->
<ng-template #stepTemplate>
    <div class="divide-y divide-line">
        <div
            *ngFor="let step of steps; let i = index"
            class="flex-between-center gap-x-5 text-sm py-1 h-12 rounded px-2"
            [ngClass]="{'hover:shadow cursor-pointer': !isStepCompleted(i)}"
            (click)="stepHandler(i)"
        >
            <span>{{ step }}</span>
            <span
                nz-icon
                class="text-2xl"
                [ngClass]="{'!text-success': isStepCompleted(i)}"
                [nzType]="isStepCompleted(i) ? 'check-circle' : 'antd:long-right-arrow'"
            ></span>
        </div>
    </div>
</ng-template>

<ng-template #stepTitleTemplate>
    <div class="w-full flex-center-center md:flex-between-center py-1">
        <div class="flex-start-center gap-x-2">
            <div class="text-base">Task list</div>

            <div class="flex-center-center px-1 text-2xs font-semibold gap-x-1 bg-gradient-to-r from-[#c9fffc] to-[#ffeba3] h-[18px] rounded-[10px]">
                <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                <span>Earn Points</span>
            </div>
        </div>

        <span nz-icon nzType="antd:v2-close" class="max-md:hidden text-base !text-[#999] cursor-pointer" (click)="getStartedVisible = false"></span>
    </div>
</ng-template>

<ng-template #notifTemplate>
    <div class="max-h-[500px] overflow-y-auto small-scrollbar text-sm">
        <app-notifications></app-notifications>
    </div>
</ng-template>

<ng-template #notifiTitleTemplate>
    <div class="w-full flex-between-center">
        <div>Notifications</div>

        <span nz-icon nzType="antd:v2-close" class="text-base !text-[#999]" (click)="notfiVisible = false"></span>
    </div>
</ng-template>

<nz-modal
    *ngIf="commonService.isMobile"
    [(nzVisible)]="getStartedVisible"
    (nzOnCancel)="getStartedVisible = false"
    [nzTitle]="stepTitleTemplate"
    [nzFooter]="null"
    [nzContent]="stepTemplate"
    nzCentered
>
</nz-modal>

<ng-template #hunterAgentPopTpl>
    <app-tg-bot-entry-card type="hunter_agent" class="block max-w-[430px]"></app-tg-bot-entry-card>
</ng-template>

<ng-template #nyxAgentPopTpl>
    <app-tg-bot-entry-card type="nyx_agent" class="block max-w-[430px]"></app-tg-bot-entry-card>
</ng-template>
